import styled from 'styled-components';

export const StyledSignature = styled.div`
  margin-top: 16px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  height: 200px;
`;
